<div class="px-5 mt-4">
  <h1>Recover Lost {{ 'audit' | customerTerm }}</h1>
  @if(pageLoading){
  <p>Loading...</p>
  }
  @if(!pageLoading && AuditList.Audits.length == 0){
    <p  class="mt-4 font-semibold text-lg">No recovery audits available. </p>
    <p class="mt-2">If you due to receive access to a recovered audit and it is not displayed please contact customer support.</p>
  }
  @if(AuditList.Audits.length>0){
  @for(audit of AuditList.Audits; track audit.AuditGUID){
  <div
    class="mt-4 border-2 border-solid border-green-700 my-1 w-full  px-4 py-2 mb-4 rounded-md shadow-[0px_0px_7px_-2px_rgba(0,0,0,0.5)]">
    <div class="flex items-center flex-row justify-between mb-2">
      <div>
        <p class="md:text-base text-sm font-semibold">{{audit.AuditName}}</p>
        <h4 class="md:text-base text-sm font-semibold"><span
            class="text-base text-green-400 mr-1">&#64;</span>{{audit.LocationName}}</h4>
      </div>
      <div class="flex flex-row pl-1">
        <p class="font-semibold md:text-base text-xs text-nowrap">
          @if(audit.HasLocalVersion){
          <span>Cloud Save & Local</span>
          }@else{
          <span>Cloud Save</span>
          }
        </p>
      </div>
    </div>
    <div class="border-t-[1px] border-t-grey-300 w-full"></div>
    <div class="mt-2 flex flex-col md:flex-row justify-between md:justify-normal">
      <div class="md:w-1/3">
        <p class="text-green-400 mr-2 text-sm">{{ 'audit' | customerTerm }} Started</p>
        <div class="flex items-baseline mt-1 px-2">
          <p class="mr-1 font-semibold">{{utilService.humanDateTime(audit.DateStarted)}}</p>
        </div>
      </div>
      <div class="mt-2 md:mt-0 md:flex-grow  md:border-l-grey-500 md:border-l-[1px] md:pl-2">
        <p class="text-green-400 mr-2 text-sm">{{ 'audit' | customerTerm }} Last Saved</p>
        <div class="flex items-baseline mt-1 px-2">
          <p class="mr-1 font-semibold">{{utilService.humanDateTime(audit.LastEdited)}}</p>
        </div>
      </div>
      <div class="flex-col flex my-2">
        <button class="btn-primary  text-sm flex items-center justify-center"
          (click)="addAuditToLocal(audit.SaveID)">Download to Device <span
            class="material-symbols-outlined text-sm">chevron_right</span></button>
      </div>
    </div>


  </div>
  }


  <!--<table class="w-full table-auto bg-standardwhite border-grey-900 border-2 report-table">
    <thead>
      <tr class="border-b-[1px] border-grey-900">
        <th class="text-left">{{ 'audit' | customerTerm }}</th>
        <th class="text-right">Started</th>
        <th class="text-right">Last Updated</th>
        <th colspan="2"></th>
      </tr>

    </thead>
    <tbody>
      @for(audit of AuditList.Audits; track audit.AuditGUID){
      <tr class="border-grey-900 border rounded-lg p-5">
        <td>{{audit.AuditName}}</td>
        <td class="text-right">{{audit.FormattedDateStarted}}</td>
        <td class="text-right">{{audit.FormattedLastEdited}}</td>
        <td></td>
        <td></td>
      </tr>
      }
    </tbody>
  </table>-->
  }
</div>
